import { Button, ButtonType } from '../../../core';

import { StatePreview, StatesTableContainer } from './Buttons.styled';
import { buttonTypes, PreviewState, previewStates } from './data';

type StatesTableProps = {
  types?: ButtonType[];
  // Keeps the test ids of two tables on one page apart.
  idPrefix: string;
};

const labelOf = (type: ButtonType) => buttonTypes.find((t) => t.value === type)?.label ?? type;

const StateCell = ({
  type,
  state,
  testId,
}: {
  type: ButtonType;
  state: PreviewState;
  testId: string;
}) => {
  if (state === 'default') {
    return (
      <Button variant={type} data-testid={testId}>
        Button
      </Button>
    );
  }
  if (state === 'disabled') {
    return (
      <Button variant={type} disabled data-testid={testId}>
        Button
      </Button>
    );
  }

  return (
    <StatePreview variant={type} $state={state} tabIndex={-1} data-testid={testId}>
      Button
    </StatePreview>
  );
};

/**
 * Every type in its five states (Figma variant set 1322:91574). Default and Disabled are live
 * buttons; Hover, Active and Focus are previews held in that state.
 */
const StatesTable = ({ types = buttonTypes.map((t) => t.value), idPrefix }: StatesTableProps) => (
  <StatesTableContainer className="mb-40">
    <table className="table">
      <thead>
        <tr>
          <th>Type</th>
          {previewStates.map((state) => (
            <th key={state.value}>{state.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {types.map((type) => (
          <tr key={type}>
            <td>{labelOf(type)}</td>
            {previewStates.map((state) => (
              <td key={state.value}>
                <StateCell
                  type={type}
                  state={state.value}
                  testId={`${idPrefix}-${type}-${state.value}`}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </StatesTableContainer>
);

export default StatesTable;
